import { getWhisper } from './whisperApi';

/**
 * Executes a function only when Whisper debug mode is enabled
 * @param fn - The function to execute in debug mode
 * @returns The result of the function if debug mode is enabled, undefined otherwise
 */
export const whenDebug = fn => {
  var _whisper$isDebugMode;
  const whisper = getWhisper();
  if (whisper !== null && whisper !== void 0 && (_whisper$isDebugMode = whisper.isDebugMode) !== null && _whisper$isDebugMode !== void 0 && _whisper$isDebugMode.call(whisper)) {
    return fn();
  }
};